import React from 'react'
import SurveyMain from '../../components/survey/SurveyMain'

const Survey = (authUser) => {
  return (
    <SurveyMain authUser={authUser} />
  )
}

export default Survey